<template>
	<div class="footer-box">
		<div class="footer">
			<div class="wrap" style="padding-bottom: 18px">
				<div class="footer-left">
					<div class="left-filing">
						<a href="http://beian.miit.gov.cn">
						<p>备案号：黑ICP备20003914号-2</p>
					</a>
					<p>开发及维护：黑龙江省隆兴公路勘测设计有限公司</p>
					</div>
					<a href="https://xyt.xcc.cn/getpcInfo?sn=1768614152596561920&language=CN&certType=8&url=*.lxtec.net.cn" 
						target="_blank" style="position: relative;display: inline-block;height: 38px;">
							<div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
							<embed src="https://program.xinchacha.com/web/1768614152596561920=*.lxtec.net.cn.svg" width="103" height="38" 
							type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
						</a>
				</div>
				<div class="footer-right">

					<!-- <p>
						<img src="@/assets/upload/xia1.png" style="margin-bottom: 8px" /><br />
						扫一扫关注我们
					</p> -->
				</div>
			</div>
			<div class="footer-w">Copyright © 2021 开发及维护：黑龙江省隆兴公路勘测设计有限公司</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {};
	},
	mounted() {},
	methods: {}
};
</script>


<style scoped>
	.footer {
		width: 100%;
		position: fixed;
		opacity: 0.7;
		border-top: solid 1px #eeeeee;
		bottom: 0px;
		overflow: hidden;
		background: #242f42;
	}
	.footer-left {
		width: 70%;
		float: left;
		padding-top: 42px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.left-filing{
		margin-right: 30px;
	}
	.footer-right {
		width: 30%;
		float: right;
		padding-top: 42px;
	}
	.footer-right p {
		width: 112px;
		text-align: center;
		float: right;
		color: #fff;
	}
	.footer-left p:nth-child(1) {
		font-size: 16px;
		font-weight: normal;
		color: #fff;
	}
	.footer-left p:nth-child(2) {
		font-size: 14px;
		color: #fff;
		padding-top: 25px;
	}
	.footer-left p:nth-child(3) {
		font-weight: normal;
		color: #fff;
		padding-top: 15px;
	}
	.footer-left p:nth-child(4) {
		font-weight: normal;
		color: #fff;
		padding-top: 15px;
	}

	.footer-w {
		text-align: center;
		color: #fff;
		border-top: solid 1px #505050;
		line-height: 50px;
	}
</style>
